export interface BreadcrumbItem {
  name: string
  path?: string
}

/** BreadcrumbList schema reflecting the actual route hierarchy. */
export function buildBreadcrumbSchema(items: BreadcrumbItem[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      ...(item.path ? { item: item.path } : {}),
    })),
  }
}
